module.exports = __webpack_public_path__ + "img/monitoring.186e8f56.svg";